// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collapse_EPfNz .ant-collapse-content-active {\n  max-height: none;\n  overflow: hidden;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Qualification/components/Collapse/style.m.less"],"names":[],"mappings":"AAAA;EAEQ,gBAAA;EACA,gBAAA;AAAR","sourcesContent":[".collapse {\n    :global(.ant-collapse-content-active) {\n        max-height: none;\n        overflow: hidden;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapse": "collapse_EPfNz"
};
export default ___CSS_LOADER_EXPORT___;
